import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';

import { media } from '../../../styles/style-utils';

import Section from '../../common/Section';
import Modal from '../../common/Modal';
import MultiColumnsGrid from './MultiColumnsGrid';
import Anchor from '../utils/Anchor';
import { blocksToComponents, BLOCK_TYPE } from '../utils/Contentful';
import Button from '../../common/Button';
import TextBlockWithIcon from '../textBlock/TextBlockWithIcon';

const Wrapper = styled(Section)`
  padding: var(--default-vertical-padding) var(--default-horizontal-padding);
  text-align: ${props => props.mobileAlignment || 'left'};

  ${media.mediumLarge`
    text-align: ${props => props.desktopAlignment || 'center'};
    padding: var(--default-vertical-padding) 1.5rem;
  `}

  ${media.large`
    padding: var(--default-vertical-padding) 3rem;
  `}
`;

const ButtonWrapper = styled.div`
  margin-top: 4rem;
`;

class MultiColumnsGridBlock extends React.Component {
  constructor() {
    super();
    this.DEFAULT_NUM_ROWS = 3;
    this.DEFAULT_NUM_COLUMNS = 3;

    this.state = {
      currentPage: 0,
      canLoadMore: false,
      blocksToDisplay: [],
      modalIsOpen: false,
      modalComponent: null,
    };
  }

  componentDidMount() {
    this.numberOfColumns = this.props.content.numberOfColumns || this.DEFAULT_NUM_COLUMNS;
    this.loadBlocks();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentPage !== this.state.currentPage) {
      this.loadBlocks();
    }
  }

  render() {
    const { blocksToDisplay, currentPage } = this.state;
    const { title, textBlock, blocks, blockId, mobileAlignment, desktopAlignment } =
      this.props.content;
    const canLoadMore =
      blocks && this.limit > 0 ? (currentPage + 1) * this.limit < blocks.length : false;

    return (
      <React.Fragment>
        <Anchor id={blockId} />
        <Wrapper mobileAlignment={mobileAlignment} desktopAlignment={desktopAlignment}>
          {get(textBlock, 'fields') && (
            <TextBlockWithIcon
              content={textBlock.fields}
              marginBottom="2rem"
              srcBlockName={`Multi Columns Grid Block - ${title}`}
            />
          )}
          <MultiColumnsGrid numberOfColumns={this.numberOfColumns}>
            {blocksToDisplay.map(block =>
              blocksToComponents({
                block,
                src: BLOCK_TYPE.MULTI_COLUMNS_GRID_BLOCK,
                openModal: this.openModal,
              })
            )}
          </MultiColumnsGrid>
          {canLoadMore && (
            <ButtonWrapper>
              <Button color="white" onClick={this.loadMore}>
                <FormattedMessage defaultMessage="Load more" id="grid.load-more" />
              </Button>
            </ButtonWrapper>
          )}
        </Wrapper>
        {this.state.modalComponent && (
          <Modal isOpen={this.state.modalIsOpen} onClose={this.closeModal}>
            {this.state.modalComponent}
          </Modal>
        )}
      </React.Fragment>
    );
  }

  loadMore = () => {
    this.setState(prevState => ({
      currentPage: prevState.currentPage + 1,
    }));
  };

  loadBlocks = () => {
    const { blocks, limit } = this.props.content;

    if (blocks) {
      if (limit <= 0) {
        this.setState({ blocksToDisplay: blocks });
      } else {
        this.limit = limit || this.numberOfColumns * this.DEFAULT_NUM_ROWS;
        const newBlocksToDisplay = blocks.slice(
          this.state.currentPage * this.limit,
          (this.state.currentPage + 1) * this.limit
        );

        this.setState(prevState => ({
          blocksToDisplay: [...prevState.blocksToDisplay, ...newBlocksToDisplay],
        }));
      }
    }
  };

  openModal = component => {
    this.setState({ modalIsOpen: true, modalComponent: component });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };
}

MultiColumnsGridBlock.propTypes = {
  content: PropTypes.object,
};

export default MultiColumnsGridBlock;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/gridBlock/MultiColumnsGridBlock.js